import ComboxboxEmailTemplate from "./ComboxboxEmailTemplate";

export default ComboxboxEmailTemplate